export default "__VITE_ASSET__CwH07VVw__"